import { openBlock as o, createElementBlock as t, createElementVNode as l } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function r(a, e) {
  return o(), t("svg", n, [...e[0] || (e[0] = [
    l("path", {
      fill: "currentColor",
      d: "M5.146 5.146a.5.5 0 0 1 .707 0l13 13a.5.5 0 0 1-.707.707l-13-13a.5.5 0 0 1 0-.707"
    }, null, -1),
    l("path", {
      fill: "currentColor",
      d: "M18.146 5.146a.5.5 0 0 1 .707.707l-13 13a.5.5 0 0 1-.707-.707z"
    }, null, -1)
  ])]);
}
const i = { render: r };
export {
  i as default,
  r as render
};
